import { withStyles } from '@material-ui/core'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { WebsiteBookingsBase } from './WebsiteBookings'

import { websiteBookingsSelector, isLoadingSelector } from 'reduxModules/selectors/BookingSelectors'
import { bookingActions } from 'reduxModules/actions/BookingActions'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  isLoading: isLoadingSelector,
  websiteBookings: websiteBookingsSelector,
})

const mapDispatchToProps = {
  subscribeWebsiteBookings: bookingActions.subscribeWebsiteBookings
}

const enhance = compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)

export const WebsiteBookings = enhance(WebsiteBookingsBase)


// WEBPACK FOOTER //
// ./src/components/WebsiteBookings/index.js